import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export const Breadcrumbs = ({ items }) => (
  <nav aria-label="Breadcrumb" data-testid="breadcrumbs" className="mb-6">
    <ol className="flex flex-wrap items-center gap-2 font-mono text-[11px] font-bold uppercase tracking-[0.18em] text-charcoal-muted">
      {items.map((item, i) => (
        <li key={item.href} className="flex items-center gap-2">
          {i > 0 && <ChevronRight className="h-3 w-3 text-bumbu" aria-hidden="true" />}
          {i < items.length - 1 ? (
            <Link to={item.href} className="transition-colors hover:text-bumbu">
              {item.label}
            </Link>
          ) : (
            <span aria-current="page" className="text-bumbu-deep">
              {item.label}
            </span>
          )}
        </li>
      ))}
    </ol>
  </nav>
);
